import WikipediaW from '../../src/legacy/WikipediaW.tsx';
export default WikipediaW;
